import { render } from "./ThreeTierWithCallout.vue?vue&type=template&id=a0d52438"
import script from "./ThreeTierWithCallout.vue?vue&type=script&lang=js"
export * from "./ThreeTierWithCallout.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/build_1ea34a31/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__